var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreviewIcon = function SvgPreviewIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0919 5.2602C13.135 5.35075 13.1693 5.43145 13.196 5.5C13.1693 5.56855 13.135 5.64925 13.0919 5.7398C12.9256 6.08892 12.6497 6.54047 12.2296 6.98395C11.4256 7.83256 10.0059 8.75 7.5 8.75C4.99409 8.75 3.57437 7.83256 2.77042 6.98395C2.35028 6.54047 2.07438 6.08892 1.90813 5.7398C1.86501 5.64925 1.83069 5.56855 1.80398 5.5C1.83069 5.43145 1.86501 5.35075 1.90813 5.2602C2.07438 4.91108 2.35028 4.45953 2.77042 4.01605C3.10939 3.65825 3.55783 3.28821 4.151 2.97986C4.05281 3.30262 4 3.64514 4 4C4 5.933 5.567 7.5 7.5 7.5C9.433 7.5 11 5.933 11 4C11 3.64514 10.9472 3.30262 10.849 2.97986C11.4422 3.28821 11.8906 3.65825 12.2296 4.01605C12.6497 4.45953 12.9256 4.91108 13.0919 5.2602ZM7.5 0.5C13.5 0.5 15 5 15 5.5C15 6 13.5 10.5 7.5 10.5C1.5 10.5 0 6 0 5.5C0 5 1.5 0.5 7.5 0.5ZM9 4C9 4.82843 8.32843 5.5 7.5 5.5C6.67157 5.5 6 4.82843 6 4C6 3.17157 6.67157 2.5 7.5 2.5C8.32843 2.5 9 3.17157 9 4Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreviewIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/previewIcon.9c1bb117.svg";
export { ForwardRef as ReactComponent };